import { render, staticRenderFns } from "./KillSelfSabotageDash.vue?vue&type=template&id=dac11764&scoped=true&"
import script from "./KillSelfSabotageDash.vue?vue&type=script&lang=js&"
export * from "./KillSelfSabotageDash.vue?vue&type=script&lang=js&"
import style0 from "./KillSelfSabotageDash.vue?vue&type=style&index=0&id=dac11764&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac11764",
  null
  
)

export default component.exports